import { render, staticRenderFns } from "./CustomerRights.vue?vue&type=template&id=67d8b0ca&scoped=true&"
import script from "./CustomerRights.vue?vue&type=script&lang=js&"
export * from "./CustomerRights.vue?vue&type=script&lang=js&"
import style0 from "./CustomerRights.vue?vue&type=style&index=0&id=67d8b0ca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d8b0ca",
  null
  
)

export default component.exports